module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av716-838a7238931a67f3ffe61977a57c2166.jpg";